// pipe: human-readable, localizable labels for operations STAGE tokens (SSOT / DRY — used by the Ops
// dashboard tiles AND the worklist stage picker, so neither renders a raw snake_case token).
//
// Stages are a fixed, known set with proper i18n keys (`com.affine.pipe.ops.stage.<stage>` in
// en.json); for any unrecognised server stage we fall back to a humanised form so the UI never shows
// e.g. "drive_management". Import discipline: only the pure shared humanizer (whose own @affine/i18n
// import is TYPE-ONLY, erased by swc), so this stays usable from the pure, happy-dom-tested seams.
import { humanizeToken, tokenLabel, type Translate } from '@affine/erp-ui';

/** snake_case → "Title case" (fallback label for stages without a dedicated i18n key). */
export const humanizeStage = humanizeToken;

/**
 * Localized label for a stage — `tokenLabel` (the ONE dynamic-key resolver, in humanize.ts)
 * specialized to `com.affine.pipe.ops.stage.<stage>`. The wrapper returns the raw key when it is
 * unknown, which the resolver detects and replaces with the humanised fallback. The dynamic key is
 * reached via the wrapper's string-index accessor (typed `() => string`) — no codegen needed, and
 * build.ts's cleanup scanner recognises the `…stage.${…}` template so the keys are never pruned.
 */
export function stageLabel(t: Translate, stage: string): string {
  return tokenLabel(t, `com.affine.pipe.ops.stage.${stage}`, stage);
}
